import { render, staticRenderFns } from "./ResultsData.vue?vue&type=template&id=034dfcf8&scoped=true&"
import script from "./ResultsData.vue?vue&type=script&lang=js&"
export * from "./ResultsData.vue?vue&type=script&lang=js&"
import style0 from "./ResultsData.vue?vue&type=style&index=0&id=034dfcf8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034dfcf8",
  null
  
)

export default component.exports